import { httpClient } from '@/services/http/httpClient'

export async function deleteTechnicalReview(id: string): Promise<void> {
  await httpClient.delete(`/ideas/evaluations/technical-review/${id}`)
}
